(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  
  // Footer collapsible functionality - Improved version
  document.addEventListener('DOMContentLoaded', function() {
    const collapsibleButtons = document.querySelectorAll('.footer-block__heading--mobile-collapsible');
    
    collapsibleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Find the content div - it's after both the button and the h2 heading
        let content = this.nextElementSibling;
        
        // Skip the h2 heading if it exists
        if (content && content.classList.contains('footer-block__heading')) {
          content = content.nextElementSibling;
        }
        
        // Ensure we found the content wrapper
        if (!content || !content.classList.contains('footer-block__collapsible-content--mobile')) {
          console.warn('Footer collapsible content not found');
          return;
        }
        
        // Toggle state
        this.setAttribute('aria-expanded', !isExpanded);
        
        // Smooth toggle with proper height calculation
        if (!isExpanded) {
          // Opening
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.add('active');
          
          // After animation, set to auto for dynamic content
          setTimeout(() => {
            if (content.classList.contains('active')) {
              content.style.maxHeight = 'none';
            }
          }, 300);
        } else {
          // Closing - first set explicit height
          content.style.maxHeight = content.scrollHeight + 'px';
          
          // Force reflow
          content.offsetHeight;
          
          // Then animate to 0
          requestAnimationFrame(() => {
            content.style.maxHeight = '0';
            content.classList.remove('active');
          });
        }
      });
    });
    
    // Handle window resize for open collapsibles
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('.footer-block__collapsible-content--mobile.active').forEach(content => {
          if (content.style.maxHeight !== '0px') {
            content.style.maxHeight = 'none';
          }
        });
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Calculate and set header height
  function setHeaderHeight() {
    const header = document.querySelector('.header-wrapper');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
  }
  
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('scroll', setHeaderHeight);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  // Counter + arrow navigation and slider behavior, matching the pattern used
  // across the other custom sections: loop-around arrows (no dead-ending at
  // the last slide), optional autoplay with pause-on-hover, a vertical-wheel
  // fix so scrolling the page over the track doesn't hijack it sideways, and
  // scroll-anchoring disabled so hover doesn't jump the page around.
  function initProductRecommendationsCarousel(root) {
    var track = root.querySelector('[id^="Slider-"]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.classList && el.classList.contains('grid__item');
    });
    if (!cards.length) return;

    var currentEl = root.querySelector('[data-pr-current]');
    var totalEl = root.querySelector('[data-pr-total]');
    var prevBtn = root.querySelector('[data-pr-prev]');
    var nextBtn = root.querySelector('[data-pr-next]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Only wire up carousel navigation (autoplay, wheel-fix, counter) when the
    // arrow controls actually exist, i.e. desktop slider mode is on with
    // enough products. Otherwise this is a plain non-scrolling grid, and
    // nothing here should intercept scroll/wheel events.
    if (prevBtn && nextBtn) {
      var page = 0;
      var timer = null;

      var pad = function (n) {
        n = n + 1;
        return n < 10 ? '0' + n : '' + n;
      };

      var cardsPerView = function () {
        var cardWidth = cards[0].getBoundingClientRect().width;
        if (!cardWidth) return 1;
        var gap = parseFloat(getComputedStyle(track).gap || getComputedStyle(track).columnGap || 0) || 0;
        var trackWidth = track.clientWidth;
        return Math.max(1, Math.floor((trackWidth + gap) / (cardWidth + gap)));
      };

      var pageCount = function () {
        return Math.max(1, Math.ceil(cards.length / cardsPerView()));
      };

      var pageWidth = function () {
        var cardWidth = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap || getComputedStyle(track).columnGap || 0) || 0;
        return (cardWidth + gap) * cardsPerView();
      };

      var updateUI = function () {
        var total = pageCount();
        if (currentEl) currentEl.textContent = pad(Math.min(page, total - 1));
        if (totalEl) totalEl.textContent = pad(total - 1);
      };

      var goTo = function (newPage) {
        var total = pageCount();
        page = Math.max(0, Math.min(newPage, total - 1));
        var maxScroll = track.scrollWidth - track.clientWidth;
        var target = Math.min(page * pageWidth(), maxScroll);
        track.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
        updateUI();
      };

      var next = function () { goTo(page + 1 >= pageCount() ? 0 : page + 1); };
      var prev = function () { goTo(page - 1 < 0 ? pageCount() - 1 : page - 1); };

      nextBtn.addEventListener('click', function () { next(); restartAutoplay(); });
      prevBtn.addEventListener('click', function () { prev(); restartAutoplay(); });

      function startAutoplay() {
        var enabled = root.getAttribute('data-autoplay') === 'true';
        var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10);
        if (!enabled || !interval || reducedMotion || cards.length < 2) return;
        timer = setInterval(next, interval);
      }

      function restartAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
          startAutoplay();
        }
      }

      startAutoplay();
      root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      root.addEventListener('mouseleave', startAutoplay);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          page = 0;
          updateUI();
        }, 200);
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var pw = pageWidth();
          if (pw) page = Math.round(track.scrollLeft / pw);
          updateUI();
        }, 100);
      });

      // Vertical wheel/trackpad scroll over the track should scroll the page,
      // not get redirected into horizontal carousel movement by the browser.
      track.addEventListener(
        'wheel',
        function (e) {
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            e.preventDefault();
            window.scrollBy(0, e.deltaY);
          }
        },
        { passive: false }
      );

      updateUI();
    }

    var revealCards = cards.filter(function (card) { return card.classList.contains('pr-reveal'); });
    if (revealCards.length) {
      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealCards.forEach(function (card) { card.classList.add('is-visible'); });
      } else {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
        );
        revealCards.forEach(function (card) { observer.observe(card); });
      }
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      // When a collection override is set, products are rendered directly by
      // Liquid on first paint (no data-url attribute) — init the carousel now,
      // there's nothing to fetch.
      if (!this.dataset.url) {
        initProductRecommendationsCarousel(this);
        return;
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.removeAttribute('data-reserve-space');
              initProductRecommendationsCarousel(this);
            } else {
              this.removeAttribute('data-reserve-space');
            }
          })
          .catch(e => {
            this.removeAttribute('data-reserve-space');
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
